import React, { useState } from 'react'
import { Heading, GContainer, Seachbar, Input, CustomBsSearch, MobileNav, ToggleMenu } from '../../style/PMCStyle/PMCNavbar'
import { CustomDiv } from '../../style/shared'
import { Grid } from '@material-ui/core'
import { PmsLogo } from '../../component/logo/Logo'
import PMCSidebar from './PMCSidebar'
import Cal from "../../assets/sidebar/calendar.svg";
import User from "../../assets/sidebar/user.svg";
import Menu from "../../assets/sidebar/menu.svg";
import Person from "../../assets/sidebar/person.svg";
import CalA from "../../assets/sidebar/calendarA.svg";
import UserA from "../../assets/sidebar/userA.svg";
import MenuA from "../../assets/sidebar/menuA.svg";
import PersonA from "../../assets/sidebar/personA.svg";

export const sidebarConfig = [
    {
      path: "",
      icon: Cal,
      activeIcon: CalA,
      alt: "Cal",
    },
    {
      path: "/Pmc/dashboard",
      icon: User,
      activeIcon: UserA,
      alt: "User",
    },
    {
      path: "",
      icon: Menu,
      activeIcon: MenuA,
      alt: "Menu",
    },
    {
      path: "",
      icon: Person,
      activeIcon: PersonA,
      alt: "Person",
    },
  ];


const PMCHeader = (props) => {
    const [openNav, setOpenNav] = useState(false)

    const handleToggle = () => {
        setOpenNav(!openNav)
    }
    return (
        <>
            {
                openNav &&
                <div className="mobSideBar" onClick={handleToggle}>
                    <PMCSidebar config={sidebarConfig} />
                    <div className='afterEffect' />
                </div>
            }
            <MobileNav>
                <Grid container style={{ margin: "0", alignItems: "center" }}>
                    <Grid item xs={6}>
                        <PmsLogo />
                    </Grid>
                    <Grid item xs={6} className='text-right'>
                        <ToggleMenu className={`text-right tootleMenu ${openNav ? "activeToggle" : ""}`} onClick={handleToggle}>
                            <span></span>
                            <span></span>
                            <span></span>
                        </ToggleMenu>
                    </Grid>
                </Grid>

            </MobileNav>
            <GContainer>
                <Grid container className='mobileCss mobCenter'>
                    <Grid item md={4} lg={3} xs={12}>
                        <Heading>
                            {props.Heading ? props.Heading : "Pharmacy System"}
                        </Heading>

                    </Grid>
                    <Grid item md={8} lg={9} xs={12}>
                        <Seachbar>
                            <CustomBsSearch />
                            <Input placeholder="Search" />
                        </Seachbar>
                    </Grid>
                </Grid>
            </GContainer>
        </>
    )
}

export default PMCHeader